module.exports = __webpack_public_path__ + "static/media/10-34.785399f1.svg";